import { cn } from '@spiaggeit/spit-ui'
import { useTranslation } from 'react-i18next'

import { ExclamationMark } from '@/assets/icons/ExclamationMark'
import { useAppSelector } from '@/hooks/store'
import { ticketSlice } from '@/store/ticketSlice'
import { formatReservationValidationMessage } from '@/utils/reservationValidationMessages'
import type { ReservationValidationError } from '@/utils/reservationValidationMessages'

interface Props {
  errors: ReservationValidationError[]
  onClick?: () => void
}

export function ReservationValidationErrors({ errors, onClick }: Props) {
  const { t } = useTranslation()
  const submitted = useAppSelector(ticketSlice.selectors.submitted)
  const validationScope = useAppSelector(ticketSlice.selectors.validationScope)

  if (!submitted || validationScope !== 'reservation' || errors.length === 0) {
    return null
  }

  const { lines, title } = formatReservationValidationMessage(t, errors)

  if (!title) {
    return null
  }

  const content = (
    <>
      <ExclamationMark className="size-5 shrink-0 text-red-600" />
      <div className="text-sm text-red-600">
        <p>{title}</p>
        {lines.length > 0 ? (
          <ul className="mt-2 list-disc space-y-1 pl-5">
            {lines.map((line) => (
              <li key={line}>{line}</li>
            ))}
          </ul>
        ) : null}
      </div>
    </>
  )

  if (onClick) {
    return (
      <button
        className={cn(
          'sticky bottom-0 z-20 mt-4 flex w-full items-start gap-2',
          'border border-red-600 bg-red-50 px-4 py-2 text-left',
          'cursor-pointer transition-colors hover:bg-red-100'
        )}
        onClick={onClick}
        type="button"
      >
        {content}
      </button>
    )
  }

  return (
    <div
      className={cn(
        'mt-4 flex items-start gap-2 border border-red-600 bg-red-50 px-4 py-2'
      )}
    >
      {content}
    </div>
  )
}
